import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OrderOriginChooseModal from './ChooseModal';
import { getOrderOriginByLabel } from '../../../utils/orderOrigin';
import * as CartActions from '../../../store/modules/cart/actions';
import * as UserActions from '../../../store/modules/user/actions';
import * as AddressesActions from '../../../store/modules/addresses/actions';

import {
  UIButton,
  UIButtonToEdit,
  UICustomInputLabel,
} from '../../UI';

const CartOrderOrigin = ({
  orderOrigin,
  tableSelectedByDefault,
  iframeRunningOn,
  isOnlineCommand,
  addOrderOrigin,
  resetUser,
  resetAdresses,
}) => {
  const [showModal, setShowModal] = useState(false);
  const selectedOrderOrigin = getOrderOriginByLabel(orderOrigin);

  const orderOriginRef = useRef(orderOrigin);
  useEffect(() => { orderOriginRef.current = orderOrigin; }, [orderOrigin]);
  const forcedRef = useRef(false);

  // Dentro do Electron (gateway), a origem ja vem "Online" por padrao. A presenca
  // do gateway e detectada por qualquer mensagem 'flash-gateway' do preload.
  // Continua editavel: e so o valor inicial (nao trava o seletor).
  useEffect(() => {
    if (!isOnlineCommand || iframeRunningOn !== 'painel') return undefined;

    const forceOnline = () => {
      if (forcedRef.current) return;
      forcedRef.current = true;
      if (orderOriginRef.current) return;
      addOrderOrigin('online');
      resetUser();
      resetAdresses();
    };
    const onMessage = (event) => {
      const data = event && event.data;
      if (!data || data.source !== 'flash-gateway') return;
      forceOnline();
    };

    window.addEventListener('message', onMessage);
    try {
      window.postMessage({ source: 'flash-platform', type: 'request-active-chat' }, '*');
    } catch (_) { /* noop */ }

    return () => window.removeEventListener('message', onMessage);
  }, [isOnlineCommand, iframeRunningOn, addOrderOrigin, resetUser, resetAdresses]);

  return (
    <>
      <UICustomInputLabel
        isRequired
        isValited={orderOrigin}
        labelTitle="Origem do pedido"
      />
      {orderOrigin ? (
        <UIButtonToEdit
          className="mb-20"
          icon={selectedOrderOrigin.icon}
          disabled={tableSelectedByDefault}
          noRightIcon={tableSelectedByDefault}
          onClick={tableSelectedByDefault ? null : () => setShowModal(true)}
          firstElement={(
            <strong>
              {selectedOrderOrigin.name}
            </strong>
          )}
        />
      ) : (
        <UIButton
          outline
          className="mb-20"
          text="Origem do pedido"
          onClick={() => setShowModal(true)}
        />
      )}
      <OrderOriginChooseModal
        showModal={showModal}
        setShowModal={setShowModal}
      />
    </>
  );
};

CartOrderOrigin.propTypes = {
  orderOrigin: PropTypes.string.isRequired,
  tableSelectedByDefault: PropTypes.bool.isRequired,
  iframeRunningOn: PropTypes.string.isRequired,
  isOnlineCommand: PropTypes.bool.isRequired,
  addOrderOrigin: PropTypes.func.isRequired,
  resetUser: PropTypes.func.isRequired,
  resetAdresses: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  orderOrigin: state.cart.orderOrigin,
  tableSelectedByDefault: state.user.tableSelectedByDefault,
  iframeRunningOn: state.establishment.iframeRunningOn,
  isOnlineCommand: state.establishment.isOnlineCommand,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  { ...CartActions, ...UserActions, ...AddressesActions },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(CartOrderOrigin);
